// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs--open{z-index:9999}.phonepicker__prefix .v-select{max-width:calc(100% - 10px);border:.5px solid rgba(0,28,45,.5);border-radius:3px;font:300 normal 14px/18px \"F37Ginger\"}.phonepicker__prefix .v-select svg{fill:currentColor}.phonepicker__prefix .v-select svg:hover{color:#616161;cursor:pointer}.phonepicker__prefix .v-select.vs--open svg{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
